export const environment = {
    production: true,
    hmr: false,
    baseURL: 'https://api-hrms.weblancertechnologies.com',
    mapboxToken: 'pk.eyJ1IjoiYW5raXRhamlhbiIsImEiOiJja3czNHF5aXUwNG91MnFtZW12MXpucTZrIn0.',
    RemarkMaxLength:10
};
